import { DEFINITIONS_BASE_PATH } from './definitions-base-path.js';

/** Shared left nav for Definitions → Platform (integrations, LDAP, automations, surveys). */
export const platformHubTabsConfig = {
    tabs: [
        {
            id: 'tenant-directory',
            path: `${DEFINITIONS_BASE_PATH}/integrations/tenant-directory`,
            pageKey: 'definitionsTenantDirectory',
        },
        {
            id: 'identity-providers',
            path: `${DEFINITIONS_BASE_PATH}/integrations/identity-providers`,
            pageKey: 'definitionsIdentityProviders',
        },
        {
            id: 'surveys',
            path: `${DEFINITIONS_BASE_PATH}/surveys`,
            pageKey: 'definitionsSurveys',
        },
        {
            id: 'survey-responses',
            path: `${DEFINITIONS_BASE_PATH}/survey-responses`,
            pageKey: 'definitionsSurveyResponses',
        },
    ],
};
